import { axiosBase, errorHandler } from "./axios";

const getRole = () => {
  return axiosBase.get("common/roleList").
  then((response) => response.data).
   catch((error) => errorHandler(error));
};

const createUser = (data: any) => {
  return axiosBase.post("users/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
};

const listUsers = (data:any) => {
  return axiosBase.get("users/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const updateUser = (data: any) => {
  return axiosBase.post("users/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const viewUser = (data: any) => {
  return axiosBase.get(`users/view/${data.id}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}



const userView = (input: any) => {
  return axiosBase.get(`users/view/${input.id}`, {
  }).then((response) => response.data).catch((error) => errorHandler(error));
};

const userUpdate = (data: any) => {
  return axiosBase.put(`users/profile`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const profileImage = (data: any) => {
  return axiosBase.post(`common/fileUpload`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getTermsByType = (type: string) => {
  return axiosBase.get("users/terms-by-type", { params: { type } })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const userService = {
  getRole,
  createUser,
  profileImage,
  listUsers,
  userUpdate,
  userView,
  viewUser,
  updateUser,
  getTermsByType,
};